import { useAuth } from '@/contexts/auth-context';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { FeatureFlag } from '@fluenceur/types';

interface UgcAvailabilityInputs {
  ugc: boolean;
  collabs: boolean;
  shopifyConnected: boolean;
}

/**
 * Whether the brand is offered UGC briefs: the UGC flag, never without
 * COLLABS, and a connected Shopify store (the product a UGC offers comes from
 * its catalog). The same three conditions the API checks before it accepts a
 * UGC brief, so nothing about UGC shows where the server would refuse it.
 */
export const ugcAvailabilityDecision = ({
  ugc,
  collabs,
  shopifyConnected,
}: UgcAvailabilityInputs): boolean => ugc && collabs && shopifyConnected;

/**
 * `ugcAvailabilityDecision` for the current brand. The Shopify state comes
 * from the session payload, like the gifting gate, rather than from the
 * integrations query that refetches on every mount. Until the flags arrive the
 * answer is false, so a surface shows today's sponsored-only version first.
 */
export const useUgcAvailability = (): boolean => {
  const ugc = useFeatureFlag(FeatureFlag.UGC);
  const collabs = useFeatureFlag(FeatureFlag.COLLABS);
  const { user } = useAuth();

  return ugcAvailabilityDecision({
    ugc,
    collabs,
    shopifyConnected: user?.integrations?.shopify?.isConnected === true,
  });
};
